import {useDispatch, useSelector} from "react-redux";
import {useFormContext} from "react-hook-form";
import {setTagOwner, setThankYouText, setIsDeclining, setIsSending, setRegistrationState, setPrintPdf} from "./reducers";
import {serialize} from "object-to-formdata";
import axios from "axios";

const useFormFieldAttributes = (formMode, field) => {
  const { formState: { errors } } = useFormContext();
  const errorMessage = (errors[formMode] && errors[formMode][field])?.message

  const labelWidth = useSelector(state => state.label_width) || "3"
  const inputWidth = useSelector(state => state.input_width) || "8"

  const title = useSelector(state => state[formMode].fields && state[formMode].fields[field]) // fieldAttributes.field_titles
  const fieldMode = useSelector(state => state[formMode].field_modes && state[formMode].field_modes[field]) // fieldAttributes.field_modes
  const placeholder = useSelector(state => state[formMode].field_placeholders && state[formMode].field_placeholders[field]) // fieldAttributes.placeholders
  const hint = useSelector(state => state[formMode].field_hints && state[formMode].field_hints[field]) // fieldAttributes.hints
  const fieldValue = useSelector(state => state[formMode].field_values && state[formMode].field_values[field]) // fieldAttributes.values
  const prefill = useSelector(state => state.disabled_prefilled_fields[field]) !== "true" // disabled_prefilled_fields 
  const fieldName = formMode + "." + field

  return {
    fieldName,
    labelWidth,
    inputWidth,
    title,
    fieldMode,
    placeholder,
    hint,
    fieldValue,
    errorMessage,
    prefill
  }
}

const useOptionValues = (formMode, field) => {
  const fieldValue = useSelector(state => state[formMode].field_values[field]) // fieldAttributes.values
  return fieldValue.split("\n").map(e => e.split("@@@"))
}

const useOnSubmit = (setError) => {
  const dispatch = useDispatch()
  //const { clearErrors } = useFormContext() funkt nicht ka wieso :(

  const saveUrl = useSelector(state => state.saveUrl)
  const prefilled = useSelector(state => state.prefix) == "prefilled"

  return (data, e) => {
    console.log(data)
    //clearErrors()
    data.decline ||= {status: "0"} // hope this does not break stuff
    const isFromDecline = data.decline.status === "1" || data.decline.status == true

    dispatch(setIsDeclining(isFromDecline))
    dispatch(setIsSending(true))

    const serializeOptions = {
      booleansAsIntegers: true,
    }

    const urlParams = new URLSearchParams(window.location.search);
    data.language = urlParams.get("language")

    data = serialize(data, serializeOptions)
    console.log("DATA", {data})

    axios({
      method: prefilled ? "put" : "post",
      url: saveUrl,
      data: data,
      headers: {'Content-Type': 'application/json'},
      timeout: 30 * 1000
    }).then(response => {
      console.debug("Submit response", response)

      if (response.data.status == "OK") {
        // This should already be handle by the thank you page
        // if (thankYouRedirectEnabled && thankYouRedirectUrl != "") {
        //   if (thankYouRedirectDelay >= 0) {
        //     setTimeout(function () {
        //       window.location = response.data.data.thank_you_redirect_url.replace("@tag_owner_id@", response.data.data.tagOwner ? response.data.data.tagOwner.id : "");
        //     }, thankYouRedirectDelay)
        //   } else {
        //     window.location = response.data.data.thank_you_redirect_url.replace("@tag_owner_id@", response.data.data.tagOwner ? response.data.data.tagOwner.id : "");
        //   }
        // }

        dispatch(setTagOwner(response.data.data.tagOwner))
        dispatch(setThankYouText(response.data.data.thankYouText)) // server side drop rendering :(
        dispatch(setRegistrationState("thank_you"))
        dispatch(setPrintPdf())
      } else {
        _.map(response.data.errors, (messages, field) => {
          setError(field, {type: "not valid", message: messages.join(",")})
        });

        if (response.data.errors["tag_owner.stop"] == "1") {
          dispatch(setRegistrationState("thank_you"))
        } else if (response.data.errors["tag_owner.full"] == "1") {
          dispatch(setRegistrationState("closed"))
        } else if (response.data.errors["tag_owner.referrer_limit_reached"] == "1") {
          dispatch(setRegistrationState("closed"))
        }

        setTimeout(function () {
          document.getElementsByClassName("is-invalid")[0]?.parentElement?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }, 200)
      }
    }).catch((response) => {
      alert(response)
      console.error(response)
    }).finally(() => {
      dispatch(setIsSending(false))
    })
  }
}

const convertFieldNameToClassName = (fieldName) => {
  return fieldName.replaceAll(".", "-")
}

export {
  useOptionValues,
  useFormFieldAttributes,
  useOnSubmit,
  convertFieldNameToClassName,
}
